import apiClient from "./apiClient";

const roleService = {
  async getRoles() {
    const response = await apiClient.get("/roles");
    return response.data?.data || response.data;
  },

  async getRoleById(id) {
    const response = await apiClient.get(`/roles/${id}`);
    return response.data?.data || response.data;
  },

  async createRole(payload) {
    const response = await apiClient.post("/roles", payload);
    return response.data?.data || response.data;
  },

  async updateRole(id, payload) {
    const response = await apiClient.patch(`/roles/${id}`, payload);
    return response.data?.data || response.data;
  },

  async deleteRole(id) {
    const response = await apiClient.delete(`/roles/${id}`);
    return response.data?.data || response.data;
  },
};

export default roleService;
